var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServ2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 202,
    viewBox: "0 0 123 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16.113 108.031C-18.803 99.6134 -14.1603 90.6093 -5.74318 87.9192C2.67395 85.2291 11.6781 89.8718 14.3682 98.289C17.0583 106.706 12.4156 115.71 3.99844 118.4C-4.4187 121.09 -13.4229 116.448 -16.113 108.031Z",
    fill: "#A1C6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4753 165.866C33.9465 161.476 48.1844 151.827 57.8521 138.502C67.5197 125.176 72.0426 108.967 70.6786 92.5345C69.3145 76.1018 62.1444 60.4219 50.3452 48.0683C38.546 35.7147 22.8187 27.4215 5.74471 24.5499L1.45714 24.7934C16.8879 27.3886 34.3414 41.5134 45.005 52.6781C55.6686 63.8427 62.1486 78.0136 63.3814 92.8648C64.6142 107.716 60.5265 122.365 51.7894 134.408C43.0522 146.451 27.6605 163.152 12.7745 167.12L17.4753 165.866Z",
    fill: "#A1C6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServ2);
export default __webpack_public_path__ + "static/media/serv-2.ac4dfb0c84264dff814f618f52c7ecb9.svg";
export { ForwardRef as ReactComponent };